import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#000000"
}
function FacBro032({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M49.65 8.9q-.4-1.7-2.75-1.2Q41.25 9 35.25 5.3q-.2-.2-.45-.3h-.05q-5.2-3.9-11.3-4.85-2.3-.25-4.8-.05-4 .25-7.25 1.6-.3.1-.65.25Q5.35 3.9 2.2 9.3q-.1.2-.2.45-.3.5-.7 1.7Q.15 13.95 0 15.9q.2-.75.5-1.45Q2.05 11.2 5.25 8.7 7.4 7.05 10 6.15q3.5-1.45 7.75-1.6h.55q.9-.05 1.75 0 6.4.45 13.5 5.55 2.15 1.75 4.6 2.6 4.6 1.5 8.8 0 2.5-1.25 2.75-3.45 0-.2-.05-.35m52.8-.2q3.2 2.5 4.75 5.75.3.7.5 1.45-.15-1.95-1.3-4.45-.4-1.2-.7-1.7-.1-.25-.2-.45-3.15-5.4-8.55-7.35-.35-.15-.65-.25Q93.05.35 89.05.1q-2.5-.2-4.8.05-6.1.95-11.3 4.85h-.05q-.25.1-.45.3-6 3.7-11.65 2.4-2.35-.5-2.75 1.2-.05.15-.05.35.25 2.2 2.75 3.45 4.2 1.5 8.8 0 2.45-.85 4.6-2.6 7.1-5.1 13.5-5.55.85-.05 1.75 0h.55q4.25.15 7.75 1.6 2.6.9 4.75 2.55z"
                    id="FacBro032__Symbol_33_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#FacBro032__Symbol_33_0_Layer0_0_FILL"
                transform="translate(138.65 117.7)"
                id="FacBro032__col1n"
            />
        </g></g>
    )
}
export default FacBro032
